import type { MascotSlot } from '@classy/theme-sdk';
import { useTheme } from './ThemeProvider.js';

export interface MascotImageProps {
  slot: MascotSlot;
  className?: string;
  alt?: string;
}

export function MascotImage(props: MascotImageProps) {
  const { slot, alt = '' } = props;
  const theme = useTheme();
  return (
    <img
      src={theme.getMascot(slot)}
      alt={alt}
      {...(props.className !== undefined ? { className: props.className } : {})}
      draggable={false}
      data-mascot-slot={slot}
      data-theme-key={theme.manifest.key}
    />
  );
}
